import { useCallback } from 'react';
import { log } from 'log';
import { prop } from 'js/utils/ramda.util';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

export const useGetGameConfig = () => {
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const gamesConfiguration = useAppSelector(prop('gamesConfiguration'));

    return useCallback((gameCode) => {
        const game = gamesConfiguration[gameCode];

        if (!game) {
            log('error', `Game with game code: ${gameCode} is not configured`);

            return;
        }

        return {
            ...game,
            ...!isDesktop && { mobileGameCode: game.mobileGameCode || game.gameCode }
        };
    }, [isDesktop, gamesConfiguration]);
};
